<template>
  <div class="team">
    <v-container >
      <v-layout row wrap>
         <v-flex
            sm=12
            xs=12
            md=12
            lg=12
          >
          <template>
            <v-card>
              <v-toolbar color="#008a43" flat><h3 class="white--text">Công cụ</h3></v-toolbar>
              <v-card-title>
                  <v-row>
                    <v-col
                        cols="12"
                        sm="6"
                        xs="12"
                        md="4"
                        lg="4"
                    >
                        <v-text-field
                          v-model="filter.LicensePlates"
                          :rules="rules.LicensePlates"
                          counter="9"
                          label="Biển số"
                          hint="Tìm kiếm bằng biển số xe"
                          persistent-hint
                          outlined
                          persistent-placeholder
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        xs="12"
                        md="6"
                        lg="5"
                      >
                        <RangeDateTimePicker lang="en" :fromDate.sync="filter.fromDate" :toDate.sync="filter.toDate"  />
                    </v-col>
                    <v-col
                        cols="6"
                        sm="6"
                        xs="12"
                        md="4"
                        lg="3"
                      >
                        <v-select
                          v-model="filter.Lane"
                          :items="ListLane"
                          label="Làn"
                          item-value="LaneID"
                          item-text="LaneName"
                          outlined
                        ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        xs="6"
                        md="4"
                        lg="1"
                      >
                         <Manager v-bind:ListFee="ListFee" v-bind:ListLane="ListLane" v-bind:Rules="rules" :isUpdated.sync="isUpdated" :ShowButton=true />
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      xs="6"
                      md="4"
                      lg="1"
                    >
                        <v-btn color="#008a43" class="white--text" @click=TimKiem >Tìm kiếm <v-icon right>mdi mdi-clipboard-text-search-outline</v-icon> </v-btn>
                        
                    </v-col>
                  <v-col
                    cols="6"
                    sm="6"
                    xs="6"
                    md="3"
                    lg="2"
                  >
                      <download-excel :data="dataExcel" header="Created by ETC Portal" footer="Created by ETC Portal" :fields="exportFields">
                        <v-btn color="#008a43" class="white--text" >Tải về <v-icon right>mdi mdi-cloud-download</v-icon></v-btn>
                      </download-excel>
                  </v-col>
                  </v-row>
              </v-card-title>              
            </v-card>
            <br />
          </template>
         </v-flex>
         <v-flex
            sm12
            xs12
            md12
            lg12
          >
          <template>
            <v-card>
              <v-toolbar color="#008a43" flat><h3 class="white--text">Danh sách vượt trạm</h3></v-toolbar>
              <v-card-title>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-col
                    cols="12"
                    md="6"
                    lg="4"
                  >
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Tìm kiếm nhanh"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="itemsWithIndex"
                :search="search"
                loading-text="Đang tải dữ liệu..."
                :footer-props="{itemsPerPageText: 'Dữ liệu mỗi trang','items-per-page-options':[10,20,30,40,50]}"
                :items-per-page="20"
              >
              <template v-slot:no-data>
                <br />
                <v-alert
                  border="right"
                  colored-border
                  type="warning"
                >
                  <v-btn text color="warning">KHÔNG CÓ DỮ LIỆU</v-btn>
                </v-alert>
              </template>
              <template v-slot:[`item.fee.FeeNumbers`]="{ item }">
                <v-btn
                  text
                  small
                >
                    {{new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(item.fee.FeeNumbers)}}
                  </v-btn>
              </template>
              <template v-slot:[`item.TrackTime`]="{ item }">
                <v-btn
                  text
                  small
                >
                    <template v-if="item.TrackTime">
                      {{item.TrackTime}}
                    </template>
                    <template v-else>
                      Chưa có dữ liệu
                    </template>
                  </v-btn>
              </template>
              <template v-slot:[`item.TrackId`]="{ item }">
                    <Manager :ListFee="ListFee" :ListLane="ListLane" :Rules="rules" :ShowButton=false ref="UpdateItem" :isUpdated.sync="isUpdated" />
                    <ControlButton :Item="item" :EditFunc="ChinhSua" :DeleteFunc="Xoa"/>
              </template>
              </v-data-table>
            </v-card>
          </template>
         </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Manager from '../components/TrackManager.vue'
import ControlButton from './../components/ControlButton.vue'
export default {
  name: 'vuot-tram',
  components: {
    Manager,
    ControlButton
  },
  computed: {
    dataExcel: function(){
      const exportData = [].concat(this.items);
      return exportData.map(item=>{
        if(typeof(item.user) !== 'undefined'){
          item.TaiKhoan = item.user.UserName;
        }
        if(typeof(item.fee) !== 'undefined'){
          item.Phi = item.fee.FeeNumbers;
        }
        if(item.lane !== undefined){
          item.Lan = item.lane.LaneName;
        }
        if(item.TrackTime !== undefined){
          item.TrackTime = this.moment(item.TrackTime).tz("Asia/Bangkok").format("DD-MM-YYYY HH:mm");
        }
        return item;
      });
    },
    itemsWithIndex: function(){
        return this.items.map(
          (items, index) => ({
            ...items,
            index: index + 1
          }))
      }
  },
  methods: {
    ChinhSua: function(item){
      if(!item.TrackId)
      {
        return;
      }
      this.loading = true;
      this.$Request.get(`/track/${item.TrackId}`).then(response => {
          const json = response.data;
          if(json.success === true)
          {
            json.data.TrackTime = new Date(json.data.TrackTime);
            this.$refs.UpdateItem.EditItem(json.data);
          }else{
            const msg = json.error || "Không tải được dữ liệu !!!";
            this.$swal.fire({
                position: 'center',
                icon: 'error',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
          }
      }).catch((error) =>{
          console.log(error);
          this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: "Không tải được dữ liệu !!!",
              showConfirmButton: false,
              timer: 1500
          });
        }).finally(()=>{
        this.loading = false;
      });
    },
    Xoa: async function(item){
      if(!item.TrackId)
      {
        return;
      }
      const result = await this.$swal.fire({
        title: 'Bạn có chắc chắn?',
        text: "Hành động này sẽ không thể phục hồi được dữ liệu !!!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Hủy',
        confirmButtonText: 'Xác nhận xóa'
      });
      if(result.isConfirmed === false)
      {
        return;
      }
      this.loading = true;
      this.$Request.delete(`/track/${item.TrackId}`).then(response => {
          const json = response.data;
          if(json.success === true)
          {
            this.LayDulieu();
            const msg = response.data.msg || "Đã xóa thành công !";
            this.$swal.fire({
                position: 'center',
                icon: 'success',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
          }else{
            const msg = json.error || "Không tải được dữ liệu !!!";
            this.$swal.fire({
                position: 'center',
                icon: 'error',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
          }
      }).catch((error) =>{
          console.log(error);
          this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: "Không tải được dữ liệu !!!",
              showConfirmButton: false,
              timer: 1500
          });
        }).finally(()=>{
        this.loading = false;
      });
    },
    TimKiem: function(){
      this.loading = true;
      this.$Request.post('/track',this.filter).then(response => {
          this.items = response.data.data;
      }).finally(()=>{
        this.loading = false;
      });
    },
    LayDulieu: function(){
      this.loading = true;
      this.$Request.get(`/track`).then(response => {
          this.ListLaneAdd = response.data.lane;
          this.ListLane = this.ListLane.concat(response.data.lane);
          this.ListFee = response.data.fee;
          this.items = response.data.track;
          //return this.items = response.data;
      }).catch(() =>{
          this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: "Không tải được dữ liệu !!!",
              showConfirmButton: false,
              timer: 1500
          });
        }).finally(()=>{
        this.loading = false;
      });
    },
  },
  watch: {
    isUpdated:function(val)
    {
      console.log(val);
      if(val === true)
      {
        this.isUpdated = undefined;
        this.LayDulieu();
      }
    },
  },
  data : () => ({
    exportFields: {
      "Biển số xe":"LicensePlates",
      "Tên Khách Hàng":"NameCustomer",
      "Thời gian":"TrackTime",
      "Ghi chú":"Notes",
      "Phí":"Phi",
      "Tài khoản":"TaiKhoan",
      "Làn":"Lan"
    },
    isUpdated: undefined,
    loading: false,
    addDefault:{

    },
    filter:{
      LicensePlates: "",
      Lane: "",
      fromDate: undefined,
      toDate: undefined,
    },
    rules: {
      LicensePlates: [v => (v.length <= 9 && v.length >= 7) || 'BKS phải từ 7-9 kí tự'],
      Required: [v => !!v || 'Điền dữ liệu vào !!!']
    },
    ListLaneAdd: [],
    ListLane: [{LaneID:"",LaneName:"TẤT CẢ"}],
    ListFee: [],
    items: [],
    search: "",
    headers: [
        { text: 'STT', align: 'center', sortable: true,value: 'index',width:"5%",class:"grey lighten-2 black--text" },
        { text: 'User', align: 'right', sortable: false,value: 'user.UserName',width:"5%",class:"grey lighten-2 black--text" },
        { text: 'Biển số xe', align: 'right', sortable: true,value: 'LicensePlates',width:"10%",class:"grey lighten-2 black--text" },
        { text: 'Tên KH', align: 'center', sortable: false,value: 'NameCustomer',width: "25%",class:"grey lighten-2 black--text" },
        { text: 'Làn', align: 'center', sortable: false,value: 'lane.LaneName',width: "5%",class:"grey lighten-2 black--text" },
        { text: 'Thời gian', align: 'center', sortable: false,value: 'TrackTime',width: "15%",class:"grey lighten-2 black--text" },
        { text: 'Mệnh giá', align: 'center', sortable: false,value: 'fee.FeeNumbers',width: "10%",class:"grey lighten-2 black--text" },
        { text: 'Ghi chú', align: 'center', sortable: false,value: 'Notes',width: "15%",class:"grey lighten-2 black--text" },
        { text: 'Thao tác', align: 'center', sortable: false,value: 'TrackId',width: "10%",class:"grey lighten-2 black--text" },
    ],
  }),
  mounted(){
    this.LayDulieu();
  }
}
</script>
